import { useQuery } from '@tanstack/react-query';
import { fetchHomeSections } from '@/entities/home/api/homeApi';

export function useHomeSections() {
  return useQuery({
    queryKey: ['home', 'sections'],
    queryFn: fetchHomeSections,
    staleTime: 60_000,
  });
}
